import * as React from 'react';
import { connect } from 'react-redux';
import { updateViewOptions } from './slice';
import { Tag, TextField } from '@cimpress/react-components';
import getSceneVariation from './selectors/getSceneVariation';
import getMerchantSettings from 'src/selectors/getSettings';
import { RootState } from 'src/store';
import { ENTER, SPACE } from 'src/util/keycodes';

interface View {
    name?: string;
    ordinal?: number;
}

interface ViewOptionsProps {
    view?: View;
    views: string[];
    updateViewOptions: (viewOptions: View) => void;
}

export function ViewOptions({ view, views, updateViewOptions }: ViewOptionsProps) {
    return (
        <div>
            <TextField
                label='Name'
                value={view?.name}
                onChange={(e) => updateViewOptions({ ...view, name: e.currentTarget.value })}
            />
            <div className='save-properties__default-tags'>
                {views.map((name) => {
                    const selected = view?.name === name;
                    const handleClick = () => updateViewOptions({ ...view, name: selected ? '' : name });
                    return (
                        <div
                            key={name}
                            role='button'
                            tabIndex={0}
                            aria-pressed={selected}
                            style={{ cursor: 'pointer' }}
                            onClick={handleClick}
                            onKeyDown={(e) => {
                                if (e.keyCode === ENTER || e.keyCode === SPACE) {
                                    e.preventDefault();
                                    handleClick();
                                }
                            }}>
                            <Tag
                                data-testid={`scene-variation-view-option_${name}`}
                                className={selected ? 'selected' : 'unselected'}
                                value={name}
                            />
                        </div>
                    );
                })}
            </div>
            <TextField
                label='Ordinal'
                type='number'
                value={view?.ordinal}
                onChange={(e) => {
                    updateViewOptions({ ...view, ordinal: e.currentTarget.valueAsNumber });
                }}
            />
        </div>
    );
}

export default connect(
    (state: RootState) => {
        const { view } = getSceneVariation(state);

        return {
            view,
            views: getMerchantSettings(state).views,
        };
    },
    { updateViewOptions },
)(ViewOptions);
